import React, { useState, createContext } from 'react'

import { languageOptions, dictionaryList } from '../../languages'

const browserLanguage = navigator.language === 'fr-FR' ? 'fr' : 'en'
const preferredLanguage = window.localStorage.getItem('rcml-lang') || browserLanguage

// create the language context with default selected language
export const LanguageContext = createContext({
  userLanguage: preferredLanguage,
  dictionary: dictionaryList.preferredLanguage
})

// it provides the language context to app
export function LanguageProvider({ children }) {
  const [userLanguage, setUserLanguage] = useState(preferredLanguage)

  const provider = {
    userLanguage,
    dictionary: dictionaryList[userLanguage],
    userLanguageChange: selected => {
      const newLanguage = languageOptions[selected] ? selected : preferredLanguage
      setUserLanguage(newLanguage)
      window.localStorage.setItem('rcml-lang', newLanguage)
    }
  }

  return (
    <LanguageContext.Provider value={provider}>
      {children}
    </LanguageContext.Provider>
  )
}
